import React from 'react';
import getConfig from 'next/config';
import { Grid, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from './styles';

const EirChannelList = ({ icons }) => {
  const theme = useTheme();
  const { publicRuntimeConfig } = getConfig();
  return (
    <Grid container sx={styles(theme).channelListRow} spacing={2}>
      {icons.length > 0 &&
        icons?.map((ele, index) => (
          <Grid
            item
            xs={2.9}
            sm={2.8}
            md={2.4}
            lg={2.4}
            key={index}
            sx={styles(theme).channelListRowElement}
          >
            <Box
              component='img'
              sx={styles(theme).channelIcon}
              alt={ele?.Logo?.data?.attributes?.alternativeText || 'icon'}
              src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${ele?.Logo?.data?.attributes?.url}`}
            />
          </Grid>
        ))}
    </Grid>
  );
};

export default EirChannelList;
